const findFeeBySlug = (slug, fees) => {
    return fees.find((fee) => fee.slug === slug);
};
export default findFeeBySlug;
